import React from 'react';

import cx from 'classnames';

import { IIntrinsicProps } from './interface';

const Intrinsic: React.FC<IIntrinsicProps> = React.forwardRef(
  (
    { width, height, isTransparent = true, noUpscale, children, style, forwardRef, ...props },
    ref
  ) => {
    const componentClass = 'nord-intrinsic';
    const classes = cx(componentClass, 'relative w-full h-0');

    return (
      <div
        style={{
          ...(noUpscale
            ? {
                maxWidth: Number(width),
                maxHeight: Number(height),
              }
            : {}),
          ...style,
        }}
        {...props}
        ref={ref || forwardRef}
      >
        <div
          className={cx(classes, isTransparent ? 'bg-transparent' : 'bg-grey-lightest')}
          style={{ paddingTop: `${(height / width) * 100}%` }}
        >
          {children}
        </div>
      </div>
    );
  }
);

export default Intrinsic;
